document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector("#chocolateCarousel");
  const productCategories = document.querySelector(".product-categories");
  const productCategoriesPopboxLink = document.querySelector(
    ".product-categories-popbox-link"
  );

  const classicChocolate = document.querySelector(".classic-chocolate");
  const theLittleBlack = document.querySelector(".the-little-black");
  const avatarBorder = document.querySelector(".avatar-border");

  const productCategoriesText = {
   // 0: { category: "Discover Our Valentine's Day Collection", description: '12 piece, 18 piece, 28 piece boxes', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/best-chocolate-boxes-and-gifts-for-valentines-day'  },
  //  0: { category: 'Ramadan Collection', description: 'Eid Jewelry Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/ramadan'  },
  //  1: {
  //     category: "Easter Collection",
  //     description: "Order Your Easter Goodies",
  //     price: "Order Now",
  //     link: "https://www.cacaoandcardamom.com/collections/easter-collection",
  //   },
  0: { category: "Mother’s Day Collectionnnnnnnnnnnnnnnnnnnnnn", description: 'Order Purse Gift Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/mothers-day-gift-boxes'  },
  // 2: { category: 'Lunar New Year Collection', description: '2 piece, 8 piece, 16 piece boxes', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/lunar-new-year'  },
    // 0: { category: "Father's Day Collection", description: 'Order Cocktail Cigar', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/fathers-day-gift-boxes'  },
    //0: { category: "Mother’s Day Collection", description: 'Order Purse Gift Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/mothers-day-gift-boxes'  },
    // 1: { category: "Easter Collection", description: 'Order Your Easter Goodies', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/easter-collection'  },
    //1: { category: "Ramadan Collection", description: 'Eid Mubarak Gift Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/ramadan'  },
    //2: { category: "Eid Collection", description: 'Eid Mubarak Crescent Gift Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/eid-collection'  },
    // 0: {
    //   category: "🎉 Celebrate with us!",
    //   description: "Our Anniversary Sale",
    //   price: "15% off site wide",
    //   link: "https://www.cacaoandcardamom.com/collections/buy-gourmet-artisan-chocolates-usa",
    // },
    // 0: {
    //   category: "Stars & Scoops Collection",
    //   description: "Dazzling 12 piece box for July 4th",
    //   price: "Order Now",
    //   link: "https://www.cacaoandcardamom.com/collections/buy-gourmet-artisan-chocolates-usa/products/stars-scoops-collection-12-piece-box",
    // },
    // 0: {
    //   category: "Holiday Chocolate Gourmet Gift Box",
    //   description: "16 piece box",
    //   price: "Order Now",
    //   link: "https://www.cacaoandcardamom.com/products/holiday-16-piece-box",
    // },
    // 1: {
    //   category: "Our limited-edition Advent Calendar is live",
    //   description: "2025 Advent",
    //   price: "Pre-order now",
    //   link: "https://www.cacaoandcardamom.com/products/2025-holiday-chocolate-advent-calendar",
    // },
    // 2: {
    //   category: "Celebrate Autumn with Bliss",
    //   description: "Fall Collection",
    //   price: "Order Now",
    //   link: "https://www.cacaoandcardamom.com/collections/fall-collection",
    // },
    // 2: {
    //   category: "New Year's Champagne Truffles",
    //   description: "12 piece",
    //   price: "Order Now",
    //   link: "https://www.cacaoandcardamom.com/products/new-years-champagne-truffles-12-piece",
    // },
    
    1: {
      category: "Love Deserves Dubai's Pistachio Knafeh",
      description: "Artisan Bar, Snack Bar",
      price: "Order Now",
      link: "https://www.cacaoandcardamom.com/collections/dubai-bar-collection",
    },
    // 2: { category: 'New Year Gift Boxes', description: 'Champagne Truffles 8pc, 16pc', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/new-year-collection'  },
    2: {
      category: "Corporate Chocolates",
      description: "Custom logo chocolates",
      price: "Order Now",
      link: "https://www.cacaoandcardamom.com/pages/corporate-gift-page",
    },
    3: {
      category: "Chocolate Snacks",
      description: "Gourmet Chocolate Snacks",
      price: "Shop Bestsellers",
      link: "https://www.cacaoandcardamom.com/collections/chocolate-snacks",
    },
    4: {
      category: "Signature Chocolate",
      description: "The Little Black Box",
      price: "Order Now",
      link: "https://www.cacaoandcardamom.com/collections/all/products/the-little-black-box-signature",
    },
    5: {
      category: "Build Your Own Box",
      description: "80pc, 48pc, 24pc, 12pc",
      price: "Build Now",
      link: "https://www.cacaoandcardamom.com/pages/make-your-own-chocolate-box",
    }
    // 0: { category: 'Holidays Collection', description: 'Holiday Chocolate Gourmet Gift Box', price: 'Order Now', link:'https://www.cacaoandcardamom.com/collections/christmas-chocolate-gifts' }
  };
  // 0: { category: 'Diwali Collection', description: 'Our Most Popular Box', price: 'Explore Now', link:'https://www.cacaoandcardamom.com/collections/diwali-collection' },
  //3: { category: 'Build Your Own Box', description: '80pc, 48pc, 24pc, 12pc', price: 'Build Now', link:'https://www.cacaoandcardamom.com/pages/make-your-own-chocolate-box' }
  // function updateProductCategories(index) {
  //   const text = productCategoriesText[index];
  //   classicChocolate.textContent = text.category;
  //   theLittleBlack.textContent = text.description;
  //   avatarBorder.textContent = text.price;
  //   productCategoriesPopboxLink.href = text.link;
  // }

  // Initialize Bootstrap carousel
  const carouselInstance = new bootstrap.Carousel(carousel);

  // Listen for slide event
  // carousel.addEventListener("slide.bs.carousel", (event) => {
  //   updateProductCategories(event.to);
  // });

  // Initialize with first slide
  // updateProductCategories(0);
});



document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      450: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 25,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 45,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var swiper = new Swiper(".mySwiper2", {
    slidesPerView: 1,
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      450: {
        slidesPerView: 1,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1440: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swiper = new Swiper(".collections1010", {
    slidesPerView: 2,
    spaceBetween: 7,

    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 20,
        allowTouchMove: false,
      },
    },
  });
});

function openModal() {
  const dropdown = document.getElementById("shop-dropdown");
  if (dropdown.style.display === "none" || dropdown.style.display === "") {
    dropdown.style.display = "flex";
  } else {
    dropdown.style.display = "none";
  }
}

function openModal1() {
  const dropdown = document.getElementById("shop-dropdown1");
  if (dropdown.style.display === "none" || dropdown.style.display === "") {
    dropdown.style.display = "flex";
  } else {
    dropdown.style.display = "none";
  }
}

// Add this JavaScript at the bottom of your HTML file or in a separate JS file
// window.onscroll = function () {
//     toggleSticky();
// };

// const navbar = document.getElementById("navbar");
// const sticky = navbar.offsetTop; // Get the initial offset position of the navbar

// function toggleSticky() {
//     if (window.pageYOffset >= sticky) {
//         navbar.classList.add("sticky-nav"); // Add sticky-nav class

//     } else {
//         navbar.classList.remove("sticky-nav"); // Remove sticky-nav class
//     }
// }
